export const ASSIGN_VALUE = 'Assign';
